interface RequestStatus {
  message: string;
  kind: Kind;
  progressBar: number;
}

type Kind = "success" | "danger" | "warning" | "dark";

const STATUS_CONFIG: { [key: number]: RequestStatus } = {
  0: { message: "Requested today", kind: "success", progressBar: 20 },
  1: { message: "Requested 1 day ago", kind: "warning", progressBar: 35 },
  2: { message: "Requested 2 days ago", kind: "warning", progressBar: 50 },
  3: { message: "Requested 3 days ago", kind: "warning", progressBar: 65 },
  4: { message: "Requested 4 days ago", kind: "danger", progressBar: 80 },
  5: { message: "Requested 5 days ago", kind: "danger", progressBar: 100 },
};

export function getRequestMessage(businessDaysAgo: number | undefined): { message: string } {
  if (businessDaysAgo === undefined) {
    return { message: "Originator not reached" };
  }

  if (businessDaysAgo > 5) {
    return { message: "Requested more than 5 days ago" };
  }
  const { message } = STATUS_CONFIG[businessDaysAgo];
  return { message };
}

export function getRequestStatusAndProgress(businessDaysAgo: number): { kind: Kind; progressBar: number } {
  if (businessDaysAgo > 5) {
    return { kind: "danger", progressBar: 100 };
  }

  const { kind, progressBar } = STATUS_CONFIG[businessDaysAgo];

  return { kind, progressBar };
}
